import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = [
    "onClick"
];
export default /*@__PURE__*/ _defineComponent({
    __name: 'assistant-suggestion-pills',
    props: {
        suggestions: {},
        variant: {}
    },
    emits: [
        "select"
    ],
    setup (__props) {
        return (_ctx, _cache)=>{
            return _openBlock(), _createElementBlock("div", {
                class: _normalizeClass([
                    "tw-flex tw-gap-1.5",
                    _ctx.variant === 'empty' ? 'tw-flex-wrap tw-justify-center' : 'tw-flex-col tw-items-start'
                ])
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestions, (suggestion)=>{
                    return _openBlock(), _createElementBlock("button", {
                        key: suggestion,
                        type: "button",
                        class: _normalizeClass([
                            "tw-rounded-lg tw-border tw-border-solid tw-px-2 tw-py-1 tw-text-xs tw-text-left tw-bg-transparent tw-cursor-pointer hover:tw-bg-sf-slate-subtle-1",
                            _ctx.variant === 'empty' ? 'tw-border-sf-slate-lighter-1 tw-text-sf-slate tw-max-w-full' : 'tw-border-sf-ai-lighter-1 tw-text-sf-ai-darker-1'
                        ]),
                        onClick: ($event)=>_ctx.$emit('select', suggestion)
                    }, _toDisplayString(suggestion), 11, _hoisted_1);
                }), 128))
            ], 2);
        };
    }
});
